<template>
  <bk-page class="indexPage">
    <img class="bk-image" :src="indexImg">
<!--    <bk-image :src="indexImg"></bk-image>-->
  </bk-page>
</template>

<script>

	import {authReq} from '@/reqService/index';

	export default {
		name: 'index',
		components: {

		},
		computed: {

		},
		data () {
			return {
				languageType: this.$bk_getLanguageType(),
				deviceType: this.$bk_getDeviceType(),
				cachedFlag: false,
				cachedDoms: [],

				showPopupType: undefined,
				indexImg: this.$bk_getImageUrl('Def_Gif_Index.gif'),
			};
		},
		async created () {

			bkLog.error('QUERY:', this.$route.query);

			// 判断分享和进入目录
			bkLog.log('启动页');


			let reloadPath = '/home';
			
			if (window.reloadPath) {
				reloadPath = window.reloadPath;
				delete window.reloadPath;
			}
			
			if (this.$bk_getAccessToken() && this.$bk_getAccessToken() != '') {
				let userInfo = await authReq.requestGetUserInfoByToken(this, {}).catch(() => {});

				if (!userInfo) {
					this.$bk_setAccessToken(undefined);
				}
				bkLog.log('Index_userInfo:', userInfo);

				if (userInfo) {
					userInfo.id = userInfo.id || userInfo.userId;

					if (!this.languageType && userInfo.language && userInfo.language.languageCode) {
						this.$bk_switchLang(userInfo.language.languageCode);
					}
					this.$bk_setUserInfo(userInfo);
				} else {
					this.$bk_setAccessToken(undefined);
				}
			}

			this.$router.replace(reloadPath);
		},
		methods: {

		}
	};
</script>

<style lang="less">

.indexPage {
  height: 100vh !important;
  background: var(--color-main);
  //.configImgUrlBc('Def_Bc_App_Index.png', var(--color-main), center / 100% no-repeat);

  > .bk-image {
    .marginCenterAuto();
    width: 254px;
    height: 72px;
    background: transparent;
  }
}

</style>